import {styled} from '../../utils';
import {keyframes} from 'emotion';
import {IconProps} from './types';
import iconGlyphsMap from './private/iconGlyphsMap';
import './private/injectIconFonts';

const spinning = keyframes({
  '0%': {
    transformOrigin: '50% 50%',
    transform: 'rotate(0deg)'
  },
  '100%': {
    transformOrigin: '50% 50%',
    transform: 'rotate(360deg)'
  }
});

export default styled('i')<IconProps>(
  {
    display: 'inline-block',
    fontStyle: 'normal',
    verticalAlign: 'baseline',
    textAlign: 'center',
    textTransform: 'none',
    lineHeight: 1,
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',

    '&:before': {
      display: 'block',
      fontFamily: 'anticon'
    }
  },
  ({spin, size, color, name}) => ({
    animation: spin || name === 'loading' ? `${spinning} 1s linear infinite` : '',
    fontSize: size || 'inherit',
    color,
    '&:before': {
      content: `'${iconGlyphsMap[name]}'`
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.tsx